import { render, staticRenderFns } from "./achievementAnalysisClass.vue?vue&type=template&id=13bb3f02&scoped=true"
import script from "./achievementAnalysisClass.vue?vue&type=script&lang=js"
export * from "./achievementAnalysisClass.vue?vue&type=script&lang=js"
import style0 from "./achievementAnalysisClass.vue?vue&type=style&index=0&id=13bb3f02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13bb3f02",
  null
  
)

export default component.exports